import axios from 'axios';
import { API } from '../constants';
const base = window.REACT_APP_BASE_API;
export default axios.create({
    baseURL: base ?? API.url
});
